import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import TopNavigation from './shared/TopNavigation';
import SEO from './SEO';
import { Phone, Mail, Send } from 'lucide-react';

const CateringPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventDate: '',
    guests: '',
    eventType: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your inquiry! We will contact you soon to discuss your catering needs.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      eventDate: '',
      guests: '',
      eventType: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen" style={{ background: '#1a1a1a' }}>
      {/* SEO */}
      <SEO 
        title="Catering Services | Pitopalvelu Vaasa | Catering Vasa"
        description="Professional catering services in Vaasa. Weddings, corporate events, private celebrations. Authentic Nepalese & Indian cuisine. Pitopalvelu Vaasassa häihin ja juhliin. Cateringtjänster i Vasa."
        keywords="catering Vaasa, pitopalvelu Vaasa, catering Vasa, wedding catering, häät catering, bröllopscatering, corporate catering, event catering, juhlapalvelu Vaasa, Indian catering, Nepalese catering"
      />
      
      {/* Top Navigation */}
      {/* <TopNavigation /> - moved to App.js */}
      
      {/* Hero Section with Background Image */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_resto-design-1/artifacts/fulpje03_FB_IMG_1759419329222.jpg"
            alt="Catering Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(26, 26, 26, 0.85), rgba(26, 26, 26, 0.9))' }} />
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6" style={{ color: '#ffffff' }}>
              Catering 
              <span className="block" style={{ color: '#C97A2B' }}>
                Services
              </span>
            </h1>
            <p className="text-lg md:text-xl max-w-3xl mx-auto leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>
              Let us bring the authentic flavors of Sunsari to your special events
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="overflow-hidden rounded-2xl shadow-2xl" data-aos="zoom-in" data-aos-delay="0">
              <img 
                src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80"
                alt="Elegant Wedding Reception Catering"
                className="w-full h-64 object-cover hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="overflow-hidden rounded-2xl shadow-2xl" data-aos="zoom-in" data-aos-delay="100">
              <img 
                src="https://images.unsplash.com/photo-1751651054926-36ea440bb06c?w=800&q=80"
                alt="Professional Buffet Catering Display"
                className="w-full h-64 object-cover hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="overflow-hidden rounded-2xl shadow-2xl" data-aos="zoom-in" data-aos-delay="200">
              <img 
                src="https://images.unsplash.com/photo-1751651054990-a458fda33224?w=800&q=80"
                alt="Celebration Food Presentation"
                className="w-full h-64 object-cover hover:scale-110 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left Column - Services & Contact */}
            <div className="space-y-8">
              {/* Services Offered */}
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <h2 className="text-3xl font-serif mb-6" style={{ color: '#C97A2B' }}>
                  Our Catering Services
                </h2>
                <ul className="space-y-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  <li className="flex items-start">
                    <span style={{ color: '#C97A2B' }} className="mr-3 text-xl">✓</span>
                    <span>Corporate Events & Business Lunches</span>
                  </li>
                  <li className="flex items-start">
                    <span style={{ color: '#C97A2B' }} className="mr-3 text-xl">✓</span>
                    <span>Weddings & Private Celebrations</span>
                  </li>
                  <li className="flex items-start">
                    <span style={{ color: '#C97A2B' }} className="mr-3 text-xl">✓</span>
                    <span>Buffet & Family-Style Service</span>
                  </li>
                  <li className="flex items-start">
                    <span style={{ color: '#C97A2B' }} className="mr-3 text-xl">✓</span>
                    <span>Custom Menu Planning</span>
                  </li>
                  <li className="flex items-start">
                    <span style={{ color: '#C97A2B' }} className="mr-3 text-xl">✓</span>
                    <span>Professional Setup & Service</span>
                  </li>
                </ul>
              </div>

              {/* Contact Information */}
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <h2 className="text-2xl font-serif mb-6" style={{ color: '#C97A2B' }}>
                  Contact for Catering
                </h2>
                <div className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <Phone className="w-6 h-6" style={{ color: '#C97A2B' }} />
                    <div>
                      <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>Call us</p>
                      <a href="tel:+358403779200" className="text-lg font-medium hover:underline" style={{ color: '#C97A2B' }}>
                        +358 40 377 9200
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Mail className="w-6 h-6" style={{ color: '#C97A2B' }} />
                    <div>
                      <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>Email us</p>
                      <a href="mailto:ravintolasunsari@gmail.com" className="text-lg font-medium hover:underline" style={{ color: '#C97A2B' }}>
                        ravintolasunsari@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="mt-6 pt-6" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
                    <p style={{ color: 'rgba(255,255,255,0.7)' }}>
                      We typically respond within 24 hours to discuss your event requirements and provide a custom quote.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Inquiry Form */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
              <h2 className="text-3xl font-serif mb-8 text-center" style={{ color: '#ffffff' }}>
                Catering <span style={{ color: '#C97A2B' }}>Inquiry</span>
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full rounded-lg px-4 py-3 placeholder-white/50 focus:outline-none transition-all duration-300"
                    style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full rounded-lg px-4 py-3 placeholder-white/50 focus:outline-none transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                      placeholder="your@email.com"
                      required
                    />
                  </div>
                  <div>
                    <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Phone *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full rounded-lg px-4 py-3 placeholder-white/50 focus:outline-none transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                      placeholder="+358 40 123 4567"
                      required
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Event Date *</label>
                    <input
                      type="date"
                      name="eventDate"
                      value={formData.eventDate}
                      onChange={handleInputChange}
                      className="w-full rounded-lg px-4 py-3 focus:outline-none transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                      required
                    />
                  </div>
                  <div>
                    <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Number of Guests *</label>
                    <input
                      type="number"
                      name="guests"
                      value={formData.guests}
                      onChange={handleInputChange}
                      className="w-full rounded-lg px-4 py-3 placeholder-white/50 focus:outline-none transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                      placeholder="Number of guests"
                      min="10"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Event Type *</label>
                  <select
                    name="eventType"
                    value={formData.eventType}
                    onChange={handleInputChange}
                    className="w-full rounded-lg px-4 py-3 focus:outline-none transition-all duration-300"
                    style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                    required
                  >
                    <option value="" style={{ background: '#1a1a1a' }}>Select event type</option>
                    <option value="corporate" style={{ background: '#1a1a1a' }}>Corporate Event</option>
                    <option value="wedding" style={{ background: '#1a1a1a' }}>Wedding</option>
                    <option value="birthday" style={{ background: '#1a1a1a' }}>Birthday Party</option>
                    <option value="private" style={{ background: '#1a1a1a' }}>Private Celebration</option>
                    <option value="other" style={{ background: '#1a1a1a' }}>Other</option>
                  </select>
                </div>

                <div>
                  <label className="block font-medium mb-2" style={{ color: '#ffffff' }}>Additional Details</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    className="w-full rounded-lg px-4 py-3 placeholder-white/50 focus:outline-none transition-all duration-300 resize-none"
                    style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ffffff' }}
                    placeholder="Tell us about your event, dietary requirements, preferences..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2"
                  style={{ background: '#C97A2B', color: '#1a1a1a' }}
                >
                  <Send className="w-5 h-5" />
                  <span>SEND INQUIRY</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CateringPage;
